import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import SideBar from "../navigation/sidebar/SideBar";
import NavBar from "../navigation/topnav/NavBar";
import StatsRow from "../components/StatsRow";
import { Link } from "react-router-dom"; // Import Link from react-router-dom
import CalendarComp from "../components/CalendarComp";
import RowTitles from "../components/RowTitles";
import "../FullCalendar.css";
import { BsUpcScan } from "react-icons/bs";
import { FaChartLine } from "react-icons/fa6";
import EventComp from "../components/EventsComp";

function Dashboard() {
  const [timeLeft, setTimeLeft] = useState({});
  const [sundayDate, setSundayDate] = useState();
  const [todayIsSunday, setTodayIsSunday] = useState(false);
  const [today, setToday] = useState();

  //function to check if today is sunday
  const isTodaySunday = () => {
    const today = new Date();
    const dayOfWeek = today.getDay();
    //console.log("day of the week", dayOfWeek);
    if (dayOfWeek === 0) {
      return true;
    }
    return false;
  };

  // Function to get the next Sunday's date
  const getNextSunday = () => {
    const today = new Date();
    const dayOfWeek = today.getDay();
    const daysUntilSunday = 7 - dayOfWeek;
    const nextSunday = new Date(today);
    nextSunday.setDate(today.getDate() + daysUntilSunday);
    nextSunday.setHours(0, 0, 0, 0); // Reset time to midnight
    return nextSunday;
  };
  // Function to format date in a readable format (e.g., Sunday, December 15, 2024)
  const formatDate = (date) => {
    const options = {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    };
    return date.toLocaleDateString(undefined, options);
  };
  // Function to calculate the time left until next Sunday
  const calculateTimeLeft = () => {
    const nextSunday = getNextSunday();
    const difference = nextSunday - new Date();

    let timeLeft = {};
    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      };
    }
    return timeLeft;
  };
  useEffect(() => {
    const retValue = isTodaySunday();
    //console.log(retValue);
    if (retValue) {
      const today = new Date();
      setToday(formatDate(today));
      setTodayIsSunday(true);
    } else {
      setTodayIsSunday(false);
      const nextSunday = getNextSunday();
      setSundayDate(formatDate(nextSunday)); // Set next Sunday date in readable format

      const timer = setInterval(() => {
        setTimeLeft(calculateTimeLeft());
      }, 1000);

      return () => clearInterval(timer);
    }
  }, []);
  return (
    <div className="d-flex" style={{ backgroundColor: "#f1f5f7" }}>
      <SideBar />

      {/* Main Content */}
      <div className="flex-grow-1">
        {/* Header */}
        <NavBar />

        {/* Dashboard Content */}
        <div className="container-fluid mt-4">
          <h4 className="mb-3">Dashboard</h4>
          {/* top stats box */}
          <StatsRow />
          <div className="row">
            <div className="col-md-5">
              <RowTitles title={"Dashboad"} child={"Next sunday"} />
            </div>
            <div className="col-md-7">
              <RowTitles title={"Dashboad"} child={"Upcoming events"} />
            </div>
          </div>
          <div className="row">
            <div className="col-md-5">
              <div
                className="shadow bg-white text-black p-3"
                style={{
                  borderRadius: 15,
                }}
              >
                {/* countdown to next sunday jsx code */}
                {!todayIsSunday ? (
                  <div className="row mt-3">
                    <h4
                      className="text-secondary mt-3"
                      style={{ textTransform: "uppercase", fontSize: 17 }}
                    >
                      Countdown to Next Sunday
                    </h4>
                    <p>{sundayDate}</p>
                    <br />
                    <small className="mt-3" style={{ fontStyle: "italic" }}>
                      Attandance for this event will only be available on{" "}
                      {sundayDate}
                    </small>
                    <div className="countdown-container text-center mt-3">
                      <div className="d-flex justify-content-center align-items-center">
                        <div className="countdown-item">
                          <div className="countdown-value">{timeLeft.days}</div>
                          <div className="countdown-label">Days</div>
                        </div>
                        <span className="countdown-separator">:</span>
                        <div className="countdown-item">
                          <div className="countdown-value">
                            {timeLeft.hours}
                          </div>
                          <div className="countdown-label">Hours</div>
                        </div>
                        <span className="countdown-separator">:</span>
                        <div className="countdown-item">
                          <div className="countdown-value">
                            {timeLeft.minutes}
                          </div>
                          <div className="countdown-label">Minutes</div>
                        </div>
                        <span className="countdown-separator">:</span>
                        <div className="countdown-item">
                          <div className="countdown-value">
                            {timeLeft.seconds}
                          </div>
                          <div className="countdown-label">Second</div>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="row">
                    <h4
                      className="text-secondary"
                      style={{ textTransform: "uppercase", fontSize: 17 }}
                    >
                      {today}
                    </h4>
                    <h6>
                      <small className="badge" style={{ color: "#33afe0" }}>
                        Attandance scanning available
                      </small>
                    </h6>
                    <br />
                    <small style={{ fontStyle: "italic" }}>
                      You can now mark attandance for this sunday
                    </small>
                    <div
                      className="countdown-container text-center"
                      style={{ backgroundColor: "white" }}
                    >
                      <Link
                        to={`/scan/${today}`}
                        className="p-3 w-100 text-dark mb-3"
                        type="submit"
                        style={{
                          backgroundColor: "#3bc0c3",
                          border: "none",
                          fontWeight: "bold",
                          fontSize: 14,
                        }}
                      >
                        <BsUpcScan className="me-2" size={20} />
                        MARK ATTANDANCE REGISTER
                      </Link>
                      <Link
                        to="#"
                        className="p-3 w-100 text-dark bg-light bg-gradient"
                        type="submit"
                        style={{
                          border: "none",
                          fontWeight: "bold",
                          fontSize: 12,
                        }}
                      >
                        <FaChartLine className="me-2" size={20} /> TRACK
                        ATTANDANCE REPORT
                      </Link>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="col-md-7">
              <EventComp />
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <RowTitles title={"Dashboad"} child={"Attandance history"} />
            </div>
            <div className="col-md-12">
              <div
                div
                className="shadow bg-white text-black p-3"
                style={{
                  borderRadius: 15,
                }}
              >
                <CalendarComp />
              </div>
            </div>
          </div>
        </div>
        {/* Charts and Analytics */}
      </div>
    </div>
  );
}

export default Dashboard;
